import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  connection: null,
  syncRun: null,
  runs: [],
  issues: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
